import styled from 'styled-components';

export const HtmlBlockStyled = styled.div`
  p {
    margin: 0;
  }
  .custom-button {
    margin-top: 16px;
  }
  .section-title::before {
    display: none;
  }
  .section-title {
    .titleBar {
      .title {
        margin: 10px 0 10px 8px;
      }
    }
  }
  .custom-block {
    background-color: #ffffff;
    color: #000000;
    display: flex;
    align-items: center;
    padding: 16px;
    border: 2px solid #e3e9ef;
    border-radius: 10px;
    justify-content: space-between;

    .custom_block_title  {
      font-size: 16px;
      font-weight: 700;
    }

    &.left {
      flex-direction: row-reverse;
    }
  }
  .image-outer {
    min-width: 108px;

    .image-wrapper {
      max-width: 100%;
      height: auto;
      border-radius: 10px;
      flex-shrink: 0;
      display: inline-block;
    }
  }
`;
